import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useExercise = () => {
  const { invalidateQuery } = useInvalidateQueries(
    QueryKey.GET_NOTIFICATIONS,
    QueryKey.GET_APPROVE_TARGET_BASED_VESTING_TASKS,
    QueryKey.GET_APPROVE_TARGET_BASED_UNFINISHED_VESTING_TASKS,
    QueryKey.GET_SNAPSHOT,
    QueryKey.GET_VESTING_TASKS,
    QueryKey.GET_POOLS,
    QueryKey.GET_SHARE_PLANS,
    QueryKey.SHARE_PLAN_STAKEHOLDERS,
    QueryKey.GET_STAKEHOLDER_OWNERSHIP_SUMMARY,
    QueryKey.GET_STAKEHOLDER_CONSOLIDATED_POSITION,
    QueryKey.GET_APPROVE_SHARE_PLANS,
    QueryKey.GET_SHARE_PLAN_VESTING_TASKS,
    QueryKey.GET_STAKEHOLDERS_WITH_GRANTS,
    QueryKey.GET_POOLS_BY_STAKEHOLDER,
  );

  const { mutate: create, isPending } = useIdempotentAppMutation([QueryKey.EXERCISE], {
    mutationFn: (
      {
        companyId,
        data,
      }: {
        companyId: string;
        data: {
          date: string;
          filesLinks?: string[];
          payout?: number;
          returnedToPool?: number;
          sarSharePrice?: number;
          value: number;
          vestingTaskId: string;
        }[];
      },
      { headers },
    ) =>
      ApiService.post(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'events', 'exercise'] },
        { body: data, headers },
      ),
    onSuccess: () => {
      invalidateQuery();
    },
  });

  return { create, isPending };
};
